module.exports = __webpack_public_path__ + "static/media/foto-bn.94d7dc9e.png";